var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hollow-dots-spinner',{attrs:{"animation-duration":1000,"dot-size":15,"dots-num":3,"color":'#ff1d5e'}})
}
var staticRenderFns = []

export { render, staticRenderFns }